module.exports = __webpack_public_path__ + "static/media/relationships.52c6a83c.svg";